import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h-2 w-2 shadow-md rounded-full absolute left-5 bg-blue-400"
}
const _hoisted_2 = { class: "flex gap-3 items-center text-13 overflow-hidden" }
const _hoisted_3 = { class: "ml-1 flex items-center gap-2" }
const _hoisted_4 = {
  key: 0,
  class: "whitespace-nowrap flex-shrink-0 text-13 text-gray-theme-600"
}
const _hoisted_5 = {
  ref: "test",
  as: "div",
  class: "text-gray-theme-400 text-opacity-50 transition hover:(text-opacity-100 text-gray-theme-500) py-2 rounded-full"
}

import { ref, computed } from 'vue';
import ShortMessage from './ShortMessage.vue';
import {
	SvgIcon,
	Tooltip,
	DropdownWithTooltip
} from '@/ui-kit';
import {
	ConversationMessage,
	useMessages
} from '@/inbox/composition';
import { useRouter } from 'vue-router';
import UnreadMarker from './UnreadMarker.vue';
import { useMoveMessage } from '../use-move-message';


export default /*#__PURE__*/_defineComponent({
  __name: 'MessagePreview',
  props: {
    message: null,
    isFocused: { type: Boolean },
    isScrolling: { type: Boolean },
    justPreview: { type: Boolean },
    isChild: { type: Boolean }
  },
  setup(__props: any, { expose }) {

const props = __props as {
	message: ConversationMessage;
	isFocused: boolean;
	isScrolling: boolean;
	justPreview?: boolean;
	isChild?: boolean;
};

const {
	messageCreatedAt,
	fullMessageCreatedAt,
	setMessageRead,
	setMessageUnread,
	deleteMessage,
	isUpdatingMessage,
	isDeletingMessage
} = useMessages();
const { openDialog } = useMoveMessage();



const isUnread = computed(
	() =>
		((props.message.content &&
		'direction' in props.message.content
			? props.message.content.direction === 'incoming'
			: !props.message.sender) &&
			!props.message.read_at) ||
		props.message.unread_children_count > 0
);

const rootLink = ref<{ $el: HTMLLinkElement }>();

function focusItem(animate = true) {
	rootLink.value?.$el.focus({
		preventScroll: true
	});
	rootLink.value?.$el.scrollIntoView({
		block: 'nearest'
	});
}

const dropdownRef =
	ref<InstanceType<typeof DropdownWithTooltip>>();

function openDropdown() {
	dropdownRef.value?.openDropdown();
}

const RootComponent = computed(() => {
	return props.justPreview ? 'button' : 'RouterLink';
});

const actions = computed(() => {
	const deleteAction = {
		title: 'Delete',
		key: 'D',
		value: 'delete'
	};

	let actions: {
		title: string;
		key: string;
		value: string;
	}[] = [];

	if (props.message.content?.direction === 'incoming') {
		actions = [
			...actions,
			props.message.read_at
				? {
						title: 'Mark as unread',
						key: 'U',
						value: 'unread'
				  }
				: {
						title: 'Mark as read',
						key: 'U',
						value: 'read'
				  }
		];
	}

	if (!props.isChild) {
		actions = [
			...actions,
			{
				title: 'Move message',
				key: 'M',
				value: 'move'
			}
		];
	}

	if (props.message.type === 'email' && !props.isChild) {
		actions = [
			...actions,
			{
				title: 'Reply',
				key: 'R',
				value: 'reply'
			}
		];
	}

	return [...actions, deleteAction];
});

const router = useRouter();

function onAction(
	action: 'read' | 'unread' | 'reply' | 'move' | 'delete'
) {
	switch (action) {
		case 'read': {
			return setMessageRead(
				props.message.conversation_id,
				props.message as any
			);
		}
		case 'unread': {
			return setMessageUnread(
				props.message.conversation_id,
				props.message as any
			);
		}
		case 'reply': {
			return router.push({
				name: 'MessageDetails',
				params: {
					leadId: props.message.conversation_id,
					messageId: props.message.uid,
					reply: 1
				}
			});
		}
		case 'move': {
			return openDialog(props.message);
		}

		case 'delete': {
			return deleteMessage(props.message);
		}
	}
}

expose({
	focusItem,
	openDropdown
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(RootComponent)), {
    to: {
			name: 'MessageDetails',
			params: {
				messageUid: __props.message.uid
			}
		},
    ref_key: "rootLink",
    ref: rootLink,
    class: _normalizeClass(["pl-10 h-11 pr-8 flex-shrink-0 border-0 border-b border-solid flex items-center justify-between relative py-2 transition group outline-none", [
			{
				'bg-gray-theme-300 bg-opacity-75': __props.isFocused
			},
			{
				'bg-blue-400 bg-opacity-5':
					_unref(isUnread) && !__props.isFocused
			},
			__props.isScrolling ? 'cursor-none' : 'cursor-pointer'
		]]),
    tabindex: "-1"
  }, {
    default: _withCtx(() => [
      (_unref(isUnread))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(ShortMessage, {
          message: __props.message,
          isUnread: _unref(isUnread)
        }, null, 8, ["message", "isUnread"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (__props.message.children_count)
          ? (_openBlock(), _createBlock(UnreadMarker, {
              key: 0,
              class: "!h-4 !w-5.5 !rounded-lg",
              count: __props.message.children_count
            }, null, 8, ["count"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(Tooltip), { placement: "bottom" }, {
          popper: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(fullMessageCreatedAt)(
							__props.message.created_at
						)), 1)
          ]),
          default: _withCtx(() => [
            (__props.message.created_at)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(messageCreatedAt)(__props.message.created_at)), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_unref(DropdownWithTooltip), {
          "tooltip-title": "Actions",
          "open-on-key": "A",
          "dropdown-placement": "bottom",
          isFocused: __props.isFocused,
          ref_key: "dropdownRef",
          ref: dropdownRef,
          actions: _unref(actions),
          disabled: 
					_unref(isDeletingMessage)(__props.message.uid) ||
					_unref(isUpdatingMessage)(__props.message.uid)
				,
          "onUpdate:modelValue": onAction
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(SvgIcon), {
                name: "DotsIcon",
                class: "h-5 w-5"
              })
            ], 512)
          ]),
          _: 1
        }, 8, ["isFocused", "actions", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["to", "class"]))
}
}

})